module.exports = __webpack_public_path__ + "img/aserveicon.44f4ff9b.png";